import KpiValueCompareInput from './kpiValueCompareInput.vue';
import { computed, reactive, watch } from 'vue';
import { Form as AForm } from 'ant-design-vue';
export default {
  name: 'KpiValueInput',
  components: {
    KpiValueCompareInput
  },
  props: {
    value: {
      type: Object,
      default: () => ({
        value: 0,
        nValue: '',
        unit: '',
        compareMode: 0
      })
    }
  },
  emits: ['update:value', 'change'],
  setup(props, {
    emit
  }) {
    const formData = reactive({
      value: 0,
      nValue: '',
      unit: '',
      compareMode: 0,
      ...props.value
    });

    // 指标值比较
    const compareKpiValue = (val1, val2) => {
      const {
        value: v1 = 0,
        nValue: nv1 = '',
        unit: u1 = '',
        compareMode: c1 = 0
      } = val1 || {};
      const {
        value: v2 = 0,
        nValue: nv2 = '',
        unit: u2 = '',
        compareMode: c2 = 0
      } = val2 || {};
      if (c1 === c2) {
        if (c1 >= 3 && c1 <= 8) {
          return v1 === v2 && u1 === u2;
        } else if (c1 === 2) {
          // 非量化指标值比较
          return nv1 === nv2;
        }
      }
      // c1 !== c3
      return false;
    };
    watch(() => props.value, val => {
      if (compareKpiValue(val, formData.value)) {
        return;
      }
      Object.assign(formData, val);
      emit('update:value', formData);
      emit('change', formData);
    }, {
      deep: true
    });
    const formItemContext = AForm.useInjectFormItemContext();

    // 是否是量化指标
    const isQuantized = computed(() => formData.compareMode >= 3 && formData.compareMode <= 8);
    // 是否是非量化指标
    const isNonQuantized = computed(() => formData.compareMode === 2);
    const handleBlur = e => {
      formItemContext.onFieldBlur();
    };
    watch(formData, val => {
      emit('update:value', val);
      emit('change', val);
      formItemContext.onFieldChange();
    }, {
      deep: true
    });
    return {
      formData,
      isQuantized,
      isNonQuantized,
      handleBlur
    };
  }
};